import { dialog } from '@microsoft/teams-js';
import { useCallback } from 'react';
import { FlightTeam } from '../../../model';
import { formatFlightTeamName } from '../../../utils/formatters';
import { getBaseUrl } from '../../../configVariables';
import { useValueDialog } from '../../../hooks/useDialog';

export const useDepartureBoardDialogs = (botId: string) => {
    const customerMessageDialog = useValueDialog<string>();

    const openSendMessageToTeamDialog = useCallback(
        (item: FlightTeam) => {
            const baseUrl = getBaseUrl();

            dialog.url.bot.open({
                size: {
                    width: 500,
                    height: 250,
                },
                title: formatFlightTeamName(item),
                url: `${baseUrl}/sendMessageToTeam/${item.id}`,
                completionBotId: botId,
            });
        },
        [botId]
    );

    const openAddMisconnectedCustomersDialog = useCallback(
        (item: FlightTeam) => {
            const baseUrl = getBaseUrl();

            dialog.url.bot.open({
                size: {
                    width: 500,
                    height: 250,
                },
                title: formatFlightTeamName(item),
                url: `${baseUrl}/addMisconnectedCustomers/${item.id}`,
                completionBotId: botId,
            });
        },
        [botId]
    );

    return {
        customerMessageDialog,
        openSendMessageToTeamDialog,
        openAddMisconnectedCustomersDialog,
        openCustomerMessageDialog: customerMessageDialog.openDialog,
    };
};
